/*
  L'Atelier de Kinaï : fiche produit (refonte 2026)
  - Galerie glissable, vignettes, flèches, compteur
  - Mise en forme des options Globo : pastilles, prix des options (+5,00 €), aperçu de la broderie,
    conseil taille, liens d'aide
  - Total (options comprises) dans le bouton, récapitulatif et barre d'achat fixe sur mobile
*/
(function () {
  var root = document.querySelector('[data-kinai-pdp]');
  if (!root) return;

  /* ---------- Prix ---------- */
  var moneyFormat = root.getAttribute('data-money-format') || '{{amount_with_comma_separator}} €';
  var basePrice = parseInt(root.getAttribute('data-price'), 10) || 0;

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals':
          return String(Math.round(cents / 100));
        case 'amount_with_comma_separator':
          return intPart + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator':
          return String(Math.round(cents / 100));
        default:
          return parts[0] + '.' + parts[1];
      }
    });
  }
  function formatPlus(cents) {
    return '+' + formatMoney(cents);
  }

  /* ---------- Galerie ---------- */
  var track = root.querySelector('[data-k-track]');
  var thumbs = root.querySelectorAll('[data-k-thumb]');
  var count = root.querySelector('[data-k-count]');
  var slides = track ? track.querySelectorAll('[data-k-slide]') : [];
  var current = 0;

  function goTo(i) {
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
  }
  function onScroll() {
    if (!track || !slides.length) return;
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    if (i === current) return;
    current = i;
    if (count) count.textContent = i + 1 + ' / ' + slides.length;
    thumbs.forEach(function (t, n) {
      t.classList.toggle('is-on', n === i);
      if (n === i && t.scrollIntoView && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
        t.parentElement.scrollTo({ left: t.offsetLeft - 16, behavior: 'smooth' });
      }
    });
  }
  if (track) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; onScroll(); });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-k-thumb'), 10)); });
  });
  var prev = root.querySelector('[data-k-prev]');
  var next = root.querySelector('[data-k-next]');
  if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
  if (next) next.addEventListener('click', function () { goTo(current + 1); });

  /* ---------- Options Globo ---------- */
  var cta = root.querySelector('[data-k-cta]');
  var shortTitle = root.getAttribute('data-short') || '';
  var priceMap = {}; // id de variante d'option -> prix (centimes)
  var fetchedHandles = {};

  // Couleurs moyennes des pastilles de fil Globo (blancs assombris pour rester lisibles)
  var threadColors = {
    'rose': '#DA93A0', 'rouge clair': '#C71723', 'rouge foncé': '#A21922', 'bleu ciel': '#8CAEC9',
    'bleu électrique': '#2B6DB8', 'bleu marine': '#294872', 'jaune': '#D4C24A', 'or clair': '#E4B026',
    'or foncé': '#D59A1F', 'vert pale': '#80BE55', 'vert pâle': '#80BE55', 'vert': '#098845',
    'vert sapin': '#317154', 'blanc cassé': '#B8AC9A', 'noisette': '#C98E4D', 'chocolat': '#8E503E',
    'blanc': '#A9A8B2', 'gris': '#9EA2A5', 'noir': '#2C2E30'
  };

  function visible(el) {
    return !!(el && el.offsetParent !== null);
  }
  function fieldOf(el) {
    var i = el.querySelector('input[data-field-name], textarea[data-field-name], select[data-field-name]');
    return i ? i.getAttribute('data-field-name') : '';
  }
  function gpoElements() {
    return Array.prototype.slice.call(root.querySelectorAll('.gpo-app .gpo-element'));
  }

  function loadPrices() {
    var inputs = root.querySelectorAll('.gpo-app input[gpo-data-product-handle]');
    inputs.forEach(function (input) {
      var h = input.getAttribute('gpo-data-product-handle');
      if (!h || fetchedHandles[h]) return;
      fetchedHandles[h] = true;
      fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return;
          p.variants.forEach(function (v) { priceMap[String(v.id)] = v.price; });
          addPriceLabels();
          update();
        })
        .catch(function () {});
    });
  }

  function addPriceLabels() {
    root.querySelectorAll('.gpo-app input[gpo-data-variant-id]').forEach(function (input) {
      var price = priceMap[input.getAttribute('gpo-data-variant-id')];
      if (!price) return;
      var item = input.closest('.gpo-ov-item');
      if (!item || item.querySelector('.k-plus')) return;
      var target = item.querySelector('.dropdown-item__value') || item.querySelector('.gpo-ov-title') || item.querySelector('label');
      if (!target) return;
      var span = document.createElement('span');
      span.className = 'k-plus';
      span.textContent = formatPlus(price);
      var help = target.querySelector('.gpo-ov-helptext');
      if (help && help.parentNode) help.parentNode.insertBefore(span, help);
      else target.appendChild(span);
    });
  }

  function addHelpers() {
    var sizeLink = root.getAttribute('data-size-link');
    var leashLink = root.getAttribute('data-leash-link');
    var sizeNote = root.getAttribute('data-size-note');
    var sizeDone = false;
    gpoElements().forEach(function (el) {
      var f = fieldOf(el);
      var label = el.querySelector('.gpo-label');
      if (!label) return;
      if (/^taille/i.test(f)) {
        if (sizeLink && !label.querySelector('.k-help')) label.appendChild(helpLink(sizeLink, '#faq-taille'));
        if (sizeNote && !sizeDone && visible(el)) {
          sizeDone = true;
          if (!el.querySelector('.k-note')) {
            var p = document.createElement('p');
            p.className = 'k-note';
            p.innerHTML = escapeHtml(sizeNote).replace(
              /écris-nous avant de commander/i,
              function (m) { return '<a href="/pages/contact">' + m + '</a>'; }
            );
            el.appendChild(p);
          }
        }
      }
      if (/^laisse/i.test(f) && leashLink && !label.querySelector('.k-help')) {
        label.appendChild(helpLink(leashLink, '#faq-laisse'));
      }
    });
  }
  function helpLink(text, href) {
    var a = document.createElement('a');
    a.className = 'k-help';
    a.href = href;
    a.textContent = text;
    a.addEventListener('click', function (e) {
      var target = document.getElementById(href.slice(1)) || document.getElementById('faq');
      if (!target) return;
      e.preventDefault();
      if (target.tagName === 'DETAILS') target.open = true;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    return a;
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function markChecked() {
    root.querySelectorAll('.gpo-app .gpo-ov-item').forEach(function (item) {
      var input = item.querySelector('input');
      item.classList.toggle('k-on', !!(input && input.checked));
    });
    // « Tour de cou : 12-20cm » devient « 12-20 cm »
    root.querySelectorAll('.gpo-app .gpo-ov-helptext').forEach(function (h) {
      var t = h.textContent;
      if (/tour de cou\s*:/i.test(t)) setText(h, t.replace(/tour de cou\s*:\s*/i, '').replace(/(\d)\s*cm/i, '$1 cm').trim());
    });
    // Pastilles couleur : afficher le choix à côté du titre
    gpoElements().forEach(function (el) {
      if (!el.querySelector('.gpo-swatches.image-swatches, .gpo-swatches.color-swatches')) return;
      var label = el.querySelector('.gpo-label');
      if (!label) return;
      var checked = el.querySelector('input:checked');
      var sel = label.querySelector('.k-sel');
      if (!sel) {
        sel = document.createElement('span');
        sel.className = 'k-sel';
        var content = label.querySelector('.label-content');
        if (content) content.appendChild(sel);
        else label.appendChild(sel);
      }
      setText(sel, checked ? ' · ' + checked.value : '');
    });
  }

  function groupEmbroidery() {
    var els = gpoElements();
    var group = els.filter(function (el) {
      var f = fieldOf(el);
      return visible(el) && (/^couleur de la broderie/i.test(f) || /^nom/i.test(f) || /prénom/i.test(f));
    });
    // classList.toggle(…, force) ne modifie le DOM que si l'état change (évite les boucles de MutationObserver)
    els.forEach(function (el) {
      var i = group.indexOf(el);
      el.classList.toggle('k-brod', i > -1);
      el.classList.toggle('k-brod--first', i === 0);
      el.classList.toggle('k-brod--last', i > -1 && i === group.length - 1);
    });

    // Aperçu du prénom brodé
    var nameEl = group.filter(function (el) { return /^nom|prénom/i.test(fieldOf(el)); })[0];
    var old = root.querySelector('.k-preview');
    if (!nameEl) { if (old) old.remove(); return; }
    var input = nameEl.querySelector('input[type="text"], input:not([type]), textarea');
    if (!input) return;
    var preview = nameEl.querySelector('.k-preview');
    if (!preview) {
      if (old) old.remove();
      preview = document.createElement('div');
      preview.className = 'k-preview';
      preview.setAttribute('aria-live', 'polite');
      nameEl.appendChild(preview);
    }
    var colorInput = root.querySelector('.gpo-app input[data-field-name^="Couleur de la broderie"]:checked');
    var colorName = colorInput ? colorInput.value.toLowerCase().trim() : '';
    var txt = (input.value || '').trim();
    var color = threadColors[colorName] || '#2B4FA8';
    var html = '<small>Aperçu' + (colorName ? ' · fil ' + escapeHtml(colorName) : '') + '</small>' + escapeHtml(txt);
    if (preview.hidden !== !txt) preview.hidden = !txt;
    if (preview.getAttribute('data-k-html') !== html + color) {
      preview.setAttribute('data-k-html', html + color);
      preview.style.color = color;
      preview.innerHTML = html;
    }
  }

  function addonsTotal() {
    var hidden = root.querySelector('input[name="properties[_gpo_addon_products]"]');
    if (hidden && hidden.value) {
      try {
        var list = JSON.parse(hidden.value);
        if (Array.isArray(list)) {
          return list.reduce(function (sum, a) {
            return sum + Math.round((parseFloat(a.p) || 0) * 100) * (parseInt(a.q, 10) || 1);
          }, 0);
        }
      } catch (e) {}
    }
    var sum = 0;
    root.querySelectorAll('.gpo-app input[gpo-data-variant-id]:checked').forEach(function (input) {
      if (input.disabled) return;
      sum += priceMap[input.getAttribute('gpo-data-variant-id')] || 0;
    });
    return sum;
  }

  function recapText() {
    var parts = [];
    var size = Array.prototype.filter.call(
      root.querySelectorAll('.gpo-app input[data-field-name^="Taille"]:checked'),
      function (i) { return !i.disabled && visible(i.closest('.gpo-element')); }
    )[0];
    var head = shortTitle + (size ? ' · ' + size.value : '');
    root.querySelectorAll('.gpo-app input[gpo-data-variant-id]:checked').forEach(function (input) {
      if (input.disabled || !visible(input.closest('.gpo-element'))) return;
      var f = input.getAttribute('data-field-name') || '';
      if (/^taille/i.test(f)) return;
      if (/^broderie/i.test(f)) parts.push('broderie');
      else if (/^laisse/i.test(f)) parts.push(input.value.toLowerCase());
      else parts.push(input.value);
    });
    return { full: head + (parts.length ? ' + ' + parts.join(' + ') : ''), size: size ? size.value : '', parts: parts };
  }

  function setText(el, t) {
    if (el && el.textContent !== t) el.textContent = t;
  }

  var comparePrice = parseInt(root.getAttribute('data-compare'), 10) || 0;
  function update() {
    var addons = addonsTotal();
    var total = basePrice + addons;
    root.querySelectorAll('[data-k-total]').forEach(function (el) { setText(el, formatMoney(total)); });
    // Prix du haut : suit les options choisies (taille, laisse, broderie…)
    setText(root.querySelector('[data-k-base]'), formatMoney(total));
    if (comparePrice > basePrice) {
      // La remise reste celle du produit (ex. -30 %) : le prix barré suit le total, options comprises
      var cmp = Math.round((total * comparePrice) / basePrice);
      root.querySelectorAll('[data-k-cmp]').forEach(function (el) { setText(el, formatMoney(cmp)); });
    }
    // Barre fixe : même libellé que le bouton principal (ex. « Mettre à jour mon panier »)
    var mainLabel = root.querySelector('button[name="add"] .k-add__label');
    var stickyB = root.querySelector('[data-k-sticky-btn]');
    if (mainLabel && stickyB) setText(stickyB, mainLabel.textContent.trim());
    var r = recapText();
    setText(root.querySelector('[data-k-recap]'), r.full);
    setText(root.querySelector('[data-k-sticky-recap]'), (r.size || shortTitle) + (r.parts.length ? ' + ' + r.parts.join(' + ') : ''));
  }

  /* Personnalisation « Non » : l'attache est en métal, sauf taille Mini chien (plastique obligatoire).
     On l'ajoute à la commande (propriété « Matière attache ») pour qu'elle apparaisse au panier et dans la commande. */
  function syncAttache() {
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var all = Array.prototype.slice.call(root.querySelectorAll('.gpo-app input[data-field-name]'));
    var perso = all.filter(function (i) { return /^personnalisation/i.test(i.getAttribute('data-field-name') || '') && i.checked && !i.disabled; })[0];
    var mat = all.filter(function (i) { return /^mati[eè]re attache/i.test(i.getAttribute('data-field-name') || ''); });
    var matShown = mat.some(function (i) { return !i.disabled && visible(i.closest('.gpo-element')); });
    var hidden = form.querySelector('input[data-k-attache]');
    var need = perso && /^non$/i.test(perso.value.trim()) && mat.length > 0 && !matShown;
    if (!need) {
      if (hidden) hidden.remove();
      return;
    }
    var size = all.filter(function (i) { return /^taille/i.test(i.getAttribute('data-field-name') || '') && i.checked && !i.disabled && visible(i.closest('.gpo-element')); })[0];
    var val = size && /mini/i.test(size.value) ? 'Plastique' : 'Métal';
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[Matière attache]';
      hidden.setAttribute('data-k-attache', '');
      form.appendChild(hidden);
    }
    if (hidden.value !== val) hidden.value = val;
  }

  function placeOptions() {
    var container = root.querySelector('.gpo-container');
    if (container && cta && container.parentElement === cta && cta.firstElementChild !== container) {
      cta.insertBefore(container, cta.firstElementChild);
    }
  }

  var scheduled = false;
  function enhance() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      if (!root.querySelector('.gpo-app')) return;
      [placeOptions, markChecked, addHelpers, groupEmbroidery, loadPrices, addPriceLabels, syncAttache, update].forEach(function (step) {
        try { step(); } catch (e) { console.warn('[Kinaï]', e); }
      });
    }, 30);
  }

  root.addEventListener('change', function () { setTimeout(enhance, 30); });
  root.addEventListener('input', function (e) {
    if (e.target && e.target.closest && e.target.closest('.gpo-app')) enhance();
  });
  root.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.gpo-app')) setTimeout(enhance, 60);
  });
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { enhance(); });
    var form = root.querySelector('product-form');
    if (form) mo.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'disabled', 'value'] });
  }
  enhance();

  /* ---------- Barre d'achat fixe (mobile) ---------- */
  var sticky = root.querySelector('[data-k-sticky]');
  var mainBtn = root.querySelector('button[name="add"]');
  var stickyBtn = root.querySelector('[data-k-sticky-btn]');
  // Toujours visible en bas de l'écran sur mobile (masquée sur ordinateur par le CSS)
  if (sticky) {
    sticky.classList.add('is-on');
    sticky.setAttribute('aria-hidden', 'false');
    if (stickyBtn) stickyBtn.tabIndex = 0;
    document.body.classList.add('kinai-has-sticky');
  }
  if (stickyBtn && mainBtn) {
    stickyBtn.addEventListener('click', function () {
      var form = root.querySelector('.k-form');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      mainBtn.click();
    });
  }
})();
